import { Input } from '@wearetla/tla-essentials-tools/partials/forms';
import '/assets/styles/partials/forms/input.scss';

export default Input;
